import { useQuery, UseQueryResult } from 'react-query';
import { WorkoutMovementRetrieve } from 'types';
import { client } from 'utils/api-client';

function useWorkoutMovement(
  workoutMovementId: string | undefined,
): UseQueryResult<{ data: WorkoutMovementRetrieve }> {
  return useQuery(
    ['workoutMovements', workoutMovementId],
    () => client.get(`workout-movements/${workoutMovementId}/`),
    {
      enabled: !!workoutMovementId,
    },
  );
}

export default useWorkoutMovement;
